/**
 * Debug switch that renders every translation key in place of its text.
 *
 * Enable with `?translationKeys=1` on any URL; disable with `?translationKeys=0`. The choice is
 * kept in sessionStorage so it survives reloads and in-app navigation in that tab only — it
 * never touches LANGUAGE_SELECTION, so the App-Locale header and the stored language stay real.
 *
 * i18next's reserved `cimode` language makes `t()` return the key itself, so no locale file
 * is loaded and nothing else in the app has to know about the switch.
 */
export const SHOW_TRANSLATION_KEYS_PARAM = 'translationKeys'
export const SHOW_TRANSLATION_KEYS_STORAGE_KEY = 'SHOW_TRANSLATION_KEYS'
export const TRANSLATION_KEYS_LANGUAGE = 'cimode'

const FALSE_VALUES = ['0', 'false', 'off', 'no']

const isEnabled = (value: string) => !FALSE_VALUES.includes(value.toLowerCase())

export const shouldShowTranslationKeys = (search = window.location.search): boolean => {
  const param = new URLSearchParams(search).get(SHOW_TRANSLATION_KEYS_PARAM)

  try {
    if (param !== null) {
      const enabled = isEnabled(param)

      if (enabled) {
        sessionStorage.setItem(SHOW_TRANSLATION_KEYS_STORAGE_KEY, '1')
      } else {
        sessionStorage.removeItem(SHOW_TRANSLATION_KEYS_STORAGE_KEY)
      }

      return enabled
    }

    return sessionStorage.getItem(SHOW_TRANSLATION_KEYS_STORAGE_KEY) === '1'
  } catch {
    return param !== null && isEnabled(param)
  }
}
